import React, { Component, Fragment } from 'react';
import Page from 'shared/Page';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { getTicketPickerSettings, isKioskMode } from 'checkout/selectors/ui';
import { setShowAccessCodeSuccess } from '../../coupon/actions/coupon';

import AlertContainer from '../../cart/containers/AlertContainer';
import CouponAlertsContainer from './CouponAlertsContainer';
import InventoryHeaderContainer from './InventoryHeaderContainer';
import InventoryContentContainer from './InventoryContentContainer';
import InventoryFooterContainer from './InventoryFooterContainer';
import ChangeDateContainer from './ChangeDateContainer';
import InventoryItemsContainer from './InventoryItemsContainer';
import PriceLevelWrapper from './PriceLevelWrapper';
import CouponEntryButton from './CouponEntryButton';
import CheckoutButton from './CheckoutButton';
import InventoryErrors from './InventoryErrors';
import KioskLayoutContainer from '../../kiosk/containers/KioskLayoutContainer';
import TicketPickerContainer from './TicketPickerContainer';
import FeeDisclosure from './FeeDisclosure';
import BestAvailableOrPyosPicker from '../../reserved-seating/containers/BestAvailableOrPyosPicker';
import SeatingChartTicketPickerContainer from '../../reserved-seating/containers/SeatingChartTicketPickerContainer';
import InventoryLoadingUI from '../containers/InventoryLoadingUI';
import Translation from '@checkout-s/Translation';

class TicketPickerPage extends Page {

    map = {
        AlertContainer:            AlertContainer,
        CouponAlertsContainer:     CouponAlertsContainer,
        InventoryHeaderContainer:  InventoryHeaderContainer,
        InventoryContentContainer: InventoryContentContainer,
        InventoryFooterContainer:  InventoryFooterContainer,
        ChangeDateContainer:       ChangeDateContainer,
        InventoryItemsContainer:   InventoryItemsContainer,
        PriceLevelWrapper:         PriceLevelWrapper,
        CouponEntryButton:         CouponEntryButton,
        CheckoutButton:            CheckoutButton,
        InventoryErrors:           InventoryErrors,
        KioskLayoutContainer:      KioskLayoutContainer,
        TicketPickerContainer:     TicketPickerContainer,
        FeeDisclosure:             FeeDisclosure,
        BestAvailableOrPyosPicker: BestAvailableOrPyosPicker,
        InventoryLoadingUI:        InventoryLoadingUI,
        SeatingChartTicketPickerContainer,
    };

    render() {
        if (this.props.loading && (this.props.isEmbed || this.props.isKiosk)) {
            return null;
        }

        if (this.props.coupon.showAccessCodeSuccess === true) {
            setTimeout(() => {
                this.props.setShowAccessCodeSuccess(false);
            }, 7000);
        }

        return(
            <Fragment>
                {this.getComponents()}
            </Fragment>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        settings: getTicketPickerSettings(!!props.isEmbeddedPicker)(state),
        loading: state.event.loading,
        ticketCount: state.reservation.ticket_count,
        coupon: state.coupon,
        isEmbed: state.ui.isEmbed,
        isKiosk: isKioskMode(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setShowAccessCodeSuccess,
    }, dispatch);
}

TicketPickerPage.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketPickerPage)
